<!-- table-page--compact/--dense en la raíz: los tokens de densidad del
     estándar (campos de 40 px, toolbar, pie y paginado apretados) para la
     cabecera y la bitácora. La cuadrícula del mes no los usa.
     Con modo «acciones» nada de esto se pinta: sólo quedan el detalle y
     la firma de abajo, que usa la pestaña «Autorizaciones». -->
<div class="pcal table-page table-page--compact table-page--dense" *ngIf="modo === 'calendario'">

  <!-- ==================== Barra del mes ==================== -->
  <div class="pcal-nav">
    <!-- Primero el mes y cómo moverse, luego las vistas: el mismo orden
         en que se ven (Hoy ‹ › mes a la izquierda, Calendario | Bitácora
         a la derecha), que es el del tabulador. -->
    <div class="pcal-nav__der">
      <button type="button" class="pcal-nav__hoy" (click)="irAHoy()"
              matTooltip="Volver al mes de hoy">
        <!-- El icono sólo sale en los teléfonos más angostos (CSS), como
             en la barra de Vacaciones. -->
        <span class="material-icons" aria-hidden="true">today</span>
        <span class="pcal-nav__hoy-txt">Hoy</span>
      </button>
      <button type="button" class="pcal-nav__btn" (click)="mueve(-1)"
              aria-label="Mes anterior" matTooltip="Mes anterior">
        <span class="material-icons">chevron_left</span>
      </button>
      <span class="pcal-nav__mes">{{ titulo }}</span>
      <button type="button" class="pcal-nav__btn" (click)="mueve(1)"
              aria-label="Mes siguiente" matTooltip="Mes siguiente">
        <span class="material-icons">chevron_right</span>
      </button>
    </div>

    <!-- Las dos maneras de mirar el mismo mes. El calendario dice qué va
         a pasar; la bitácora, qué se pidió y en qué paró —ahí sí salen
         los que no se autorizaron y los que se retiraron. -->
    <div class="pcal-vistas" role="tablist">
      <button type="button" class="pcal-vista" role="tab"
              [class.es-on]="vista === 'calendario'"
              [attr.aria-selected]="vista === 'calendario'"
              (click)="verVista('calendario')">
        <span class="material-icons">calendar_month</span>
        Calendario
      </button>
      <button type="button" class="pcal-vista" role="tab"
              [class.es-on]="vista === 'bitacora'"
              [attr.aria-selected]="vista === 'bitacora'"
              (click)="verVista('bitacora')">
        <span class="material-icons">receipt_long</span>
        Bitácora
      </button>
    </div>
  </div>

  <!-- Lo que hubo en el mes, de un vistazo. Va en su propio renglón: en
       la barra de arriba competía por el ancho con el cambio de mes. -->
  <div class="pcal-resumen" *ngIf="!cargando && vista === 'calendario'">
    <span class="pcal-chip" *ngFor="let r of resumen" [ngClass]="r.clase">
      <b>{{ r.cuantos }}</b> {{ r.etiqueta }}
    </span>
    <span class="pcal-chip es-pend" *ngIf="pendientes">
      <b>{{ pendientes }}</b> sin resolver
    </span>
  </div>

  <div class="pcal-error" *ngIf="error">
    <span class="material-icons">error_outline</span> {{ error }}
  </div>

  <!-- Lo que espera respuesta ya no se enlista aquí (13/10/2026): va en
       la pestaña «Autorizaciones». En el mes se sigue viendo en su día. -->

  <!-- ==================== La cuadrícula ==================== -->
  <div class="pcal-tabla" *ngIf="!error && vista === 'calendario'">
    <div class="pcal-encab">
      <div class="pcal-encab__dia" *ngFor="let d of DIAS">{{ d }}</div>
    </div>

    <div class="pcal-semana" *ngFor="let s of semanas">
      <div class="pcal-dia"
           *ngFor="let d of s; trackBy: trackDia"
           [class.es-vacio]="!d.iso"
           [class.es-hoy]="d.esHoy">
        <span class="pcal-dia__num" *ngIf="d.numero">{{ d.numero }}</span>

        <div class="pcal-dia__lista">
          <!-- tabindex y click: la información no puede vivir sólo en el
               hover. Mismo criterio que el calendario de vacaciones. -->
          <!-- El clic abre el detalle, donde además se resuelve: antes
               sólo mostraba el tooltip y había que salir a la pestaña de
               Permisos a buscar el mismo permiso para responderlo. El
               tooltip se queda para el vistazo rápido con el mouse. -->
          <div class="pcal-tag"
               *ngFor="let p of d.permisos; trackBy: trackPermiso"
               tabindex="0"
               role="button"
               [ngClass]="clase(p)"
               [attr.aria-label]="tip(p)"
               (click)="abre(p)"
               (keydown.enter)="abre(p)"
               (keydown.space)="abre(p); $event.preventDefault()"
               [matTooltip]="tip(p)"
               matTooltipClass="pcal-tip"
               matTooltipPosition="above"
               [matTooltipShowDelay]="220">
            <span class="material-icons pcal-tag__icono">{{ icono(p) }}</span>
            <span class="pcal-tag__nombre">{{ p.colaborador }}</span>
            <span class="pcal-tag__ini">{{ iniciales(p.colaborador) }}</span>
            <span class="pcal-tag__hora" *ngIf="p.hora">{{ p.hora }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ==================== Leyenda ==================== -->
  <div class="pcal-leyenda" *ngIf="!error && vista === 'calendario'">
    <span class="pcal-ley"><i class="es-falta"></i> Falta el día</span>
    <span class="pcal-ley"><i class="es-salida"></i> Sale antes</span>
    <span class="pcal-ley"><i class="es-entrada"></i> Llega tarde</span>
    <span class="pcal-ley"><i class="es-rayado"></i> Sin resolver</span>
  </div>

  <div class="pcal-cargando" *ngIf="cargando && vista === 'calendario'">
    <span class="material-icons">hourglass_top</span> Consultando…
  </div>

  <!-- ==================== La bitácora ====================
       El registro del mes: todo lo que se pidió y en qué paró, con los
       rechazados y los retirados, que el calendario no pinta. -->
  <ng-container *ngIf="vista === 'bitacora'">
    <div class="pcal-cargando" *ngIf="cargandoBitacora">
      <span class="material-icons">hourglass_top</span> Consultando…
    </div>

    <!-- Mes sin permisos: la tarjeta sólo lleva el vacío. -->
    <section class="table-page__card" *ngIf="!cargandoBitacora && !bitacora.length">
      <div class="table-page__empty">
        <span class="material-icons">event_available</span>
        <h3>No se pidió ningún permiso en {{ titulo }}.</h3>
      </div>
    </section>

    <!-- Una sola tarjeta del estándar: filtros en su toolbar, la tabla
         debajo y el pie con el conteo y el paginado. -->
    <section class="table-page__card" *ngIf="!cargandoBitacora && bitacora.length">
      <!-- Los tres filtros. Trabajan sobre el mes ya cargado, así que
           responden al instante y sin volver a preguntar al servidor.
           Son los campos del estándar (mat-form-field outline con los
           tokens de 40 px de table-page--dense), como en la pestaña de
           Permisos; el select va nativo con matNativeControl. -->
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Buscar</mat-label>
              <input matInput aria-label="Buscar" type="text" name="fBusca" [(ngModel)]="fBusca"
                     (ngModelChange)="filtra()" maxlength="60"
                     placeholder="Buscar persona, quién resolvió o el motivo…" />
              <button matIconSuffix type="button" class="table-page__action-btn" *ngIf="fBusca"
                      (click)="fBusca = ''; filtra()"
                      aria-label="Limpiar búsqueda" title="Limpiar búsqueda">
                <span class="material-icons">close</span>
              </button>
              <span matIconSuffix class="material-icons pcal-lupa" *ngIf="!fBusca">search</span>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Tipo</mat-label>
              <select matNativeControl aria-label="Tipo" name="fTipo" [(ngModel)]="fTipo" (ngModelChange)="filtra()">
                <option value="">Todos</option>
                <option *ngFor="let t of TIPOS" [value]="t.valor">{{ t.texto }}</option>
              </select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Estado</mat-label>
              <select matNativeControl aria-label="Estado" name="fEstatus" [(ngModel)]="fEstatus" (ngModelChange)="filtra()">
                <option value="">Todos</option>
                <option *ngFor="let e of ESTADOS" [value]="e.valor">{{ e.texto }}</option>
              </select>
            </mat-form-field>
          </div>
        </div>

        <!-- Sólo con algo puesto: un botón de limpiar permanente invita a
             pulsarlo sin que haya nada que limpiar. -->
        <div class="table-page__toolbar-actions" *ngIf="hayFiltro">
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                  (click)="limpiaFiltros()">
            <span class="material-icons">filter_alt_off</span>
            Limpiar
          </button>
        </div>
      </div>

      <!-- Filtrado a cero: se distingue del mes vacío, porque lo que hay
           que hacer es distinto (quitar el filtro, no cambiar de mes).
           Sin botón propio: el Limpiar de la toolbar ya está a la vista,
           y el vacío del estándar es icono + título. -->
      <div class="table-page__empty" *ngIf="!bitaFiltrada.length">
        <span class="material-icons">search_off</span>
        <h3>Ningún permiso de {{ titulo }} coincide con lo que buscas.</h3>
      </div>

      <ng-container *ngIf="bitaFiltrada.length">
      <!-- La tabla del estándar (table-page__table): sólo los anchos, el
           centrado y el recorte de la nota son de esta pantalla. -->
      <div class="table-page__table-wrap">
        <table class="table-page__table">
          <thead>
            <tr>
              <th class="pcal-bita__dia">Día</th>
              <th>Colaborador</th>
              <th>Permiso</th>
              <th class="c">Goce</th>
              <th class="c">Estado</th>
              <th>Resolvió</th>
              <th class="c table-page__actions-head">FRC</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of bitaPagina(); trackBy: trackPermiso">
              <td class="pcal-bita__dia">{{ fechaCorta(p.fecha) }}</td>

              <td>
                <span class="table-page__name pcal-bita__quien">{{ p.colaborador }}</span>
              </td>

              <td>
                <span class="pcal-bita__que">
                  <span class="material-icons" [ngClass]="clase(p)">{{ icono(p) }}</span>
                  {{ bitaQue(p) }}
                </span>
                <!-- El motivo del rechazo antes que la observación: es la
                     respuesta, y es lo que se viene a consultar. -->
                <span class="pcal-bita__nota" *ngIf="bitaNota(p)"
                      [class.es-motivo]="esMotivo(p)"
                      [matTooltip]="bitaNota(p)" matTooltipClass="pcal-tip">
                  {{ bitaNota(p) }}
                </span>
              </td>

              <td class="c">
                <span class="table-page__status-badge is-inactive" *ngIf="p.goce; else sinGoce">
                  {{ p.goce === 'CON' ? 'Con goce' : 'Sin goce' }}
                </span>
                <ng-template #sinGoce><span class="pcal-bita__vacio">—</span></ng-template>
              </td>

              <td class="c">
                <span class="table-page__status-badge" [ngClass]="claseEstatus(p)">
                  {{ textoEstatus(p) }}
                </span>
              </td>

              <td>
                <span class="pcal-bita__resolvio" *ngIf="p.autorizaNombre; else sinResolver">
                  {{ p.autorizaNombre }}
                </span>
                <ng-template #sinResolver>
                  <span class="pcal-bita__vacio">—</span>
                </ng-template>
              </td>

              <td class="c table-page__actions">
                <button type="button" class="table-page__action-btn" *ngIf="tieneFrc(p)"
                        [disabled]="generandoFrc === p.idPermiso"
                        (click)="frcDe(p)" aria-label="Bajar el FRC-017"
                        matTooltip="Bajar el FRC-017" matTooltipClass="pcal-tip">
                  <span class="material-icons">picture_as_pdf</span>
                </button>
                <!-- El FRC-017 firmado a mano, si ya se subió. Subirlo o
                     reemplazarlo va en el detalle del permiso. Desde el
                     15/10/2026 también el de lo negado o retirado (RH lo
                     consulta: sin poder subir, sólo sale si hay uno), y
                     como quien administra es RH, «ver» abre el historial
                     con quién lo subió y cuándo. -->
                <app-frc-firmado variante="icono"
                                 tipo="PERMISO"
                                 [id]="p.idPermiso"
                                 [enPapel]="!!p.enPapel"
                                 [firmado]="p.firmado"
                                 [gestiona]="true"
                                 [puedeSubir]="false"></app-frc-firmado>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pie del estándar: una sola línea de conteo (el mes ya lo dice
           la barra de arriba) y, sólo con más de una página, el paginado. -->
      <div class="table-page__footer">
        <div class="table-page__meta">
          <span *ngIf="bitaTotalPaginas() > 1; else unaPagina">
            Mostrando {{ bitaInicio() }}–{{ bitaFin() }} de {{ bitaFiltrada.length }}<ng-container *ngIf="hayFiltro"> (de {{ bitacora.length }})</ng-container>
          </span>
          <ng-template #unaPagina>
            <span>
              <b>{{ bitaFiltrada.length }}</b>
              {{ bitaFiltrada.length === 1 ? "permiso" : "permisos" }}<ng-container *ngIf="hayFiltro"> de {{ bitacora.length }}</ng-container>
            </span>
          </ng-template>
        </div>
        <nav class="table-page__pager" *ngIf="bitaTotalPaginas() > 1" aria-label="Paginación">
          <button type="button" class="table-page__pager-link" (click)="bitaIr(1)"
                  [disabled]="bitaNorm() <= 1" title="Primera página" aria-label="Primera página">
            <span class="material-icons">first_page</span>
          </button>
          <button type="button" class="table-page__pager-link" (click)="bitaIr(bitaNorm() - 1)"
                  [disabled]="bitaNorm() <= 1" title="Página anterior" aria-label="Página anterior">
            <span class="material-icons">chevron_left</span>
          </button>
          <ng-container *ngFor="let p of bitaPaginas()">
            <button *ngIf="esPagina(p)" type="button" class="table-page__pager-page"
                    [class.is-current]="p === bitaNorm()"
                    (click)="bitaIr(p)">{{ p }}</button>
            <span *ngIf="!esPagina(p)" class="table-page__pager-ellipsis">…</span>
          </ng-container>
          <button type="button" class="table-page__pager-link" (click)="bitaIr(bitaNorm() + 1)"
                  [disabled]="bitaNorm() >= bitaTotalPaginas()" title="Página siguiente" aria-label="Página siguiente">
            <span class="material-icons">chevron_right</span>
          </button>
          <button type="button" class="table-page__pager-link" (click)="bitaIr(bitaTotalPaginas())"
                  [disabled]="bitaNorm() >= bitaTotalPaginas()" title="Última página" aria-label="Última página">
            <span class="material-icons">last_page</span>
          </button>
        </nav>
      </div>
      </ng-container>
    </section>
  </ng-container>
</div>

<!-- ==================== El detalle de un permiso ====================
     Se abre al tocar el permiso en el mes. Lleva lo que hace falta para
     decidir —quién, qué día, qué pidió y por qué— y los botones para
     responderlo sin salir del calendario. -->
<div class="pcal-modal" *ngIf="abierto" (click)="cierra()" (keydown.enter)="$event.target === $event.currentTarget ? cierra() : null">
  <div class="pcal-modal__caja" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <div class="pcal-modal__cab">
      <span class="material-icons pcal-modal__ico" [ngClass]="clase(abierto)">
        {{ icono(abierto) }}
      </span>
      <div class="pcal-modal__quien">
        <b>{{ abierto.colaborador }}</b>
        <span>{{ fechaLarga(abierto.fecha) }}</span>
      </div>
      <button type="button" class="pcal-modal__x" (click)="cierra()"
              aria-label="Cerrar">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="pcal-modal__cuerpo">
      <p class="pcal-modal__que">{{ resumenCorto(abierto) }}</p>

      <div class="pcal-modal__datos">
        <span class="pcal-modal__estado" [ngClass]="clase(abierto)">
          {{ etiquetaEstatus(abierto) }}
        </span>
        <span class="pcal-modal__goce" *ngIf="abierto.goce">
          {{ abierto.goce === 'CON' ? 'Con goce de sueldo' : 'Sin goce de sueldo' }}
        </span>
      </div>

      <p class="pcal-modal__obs" *ngIf="abierto.observaciones">
        “{{ abierto.observaciones }}”
      </p>

      <!-- Firmado en papel («Descargar para firmar»): quien administra lo
           ve y, si le entregan el papel, lo sube o lo reemplaza. Va en su
           propio renglón: junto a No autorizar y Autorizar ya no cabe.
           Desde el 15/10/2026 quien administra (RH) también carga el
           documento de lo de otro aunque se haya firmado en digital; de lo
           propio, sólo el papel, como antes. -->
      <div class="pcal-modal__firmado"
           *ngIf="tieneFrc(abierto) && (abierto.enPapel || abierto.firmado || !abierto.esMio)">
        <span class="pcal-modal__firmado-txt">{{ abierto.enPapel ? 'Firmado en papel' : 'Documento' }}</span>
        <app-frc-firmado variante="mini"
                         tipo="PERMISO"
                         [id]="abierto.idPermiso"
                         [enPapel]="!!abierto.enPapel"
                         [firmado]="abierto.firmado"
                         [gestiona]="true"
                         [puedeSubir]="!!abierto.enPapel || !abierto.esMio"
                         (cambio)="abierto.firmado = $event"></app-frc-firmado>
      </div>

      <p class="pcal-modal__pie" *ngIf="abierto.autorizaNombre">
        {{ abierto.estatus === 'AUTORIZADO' ? 'Autorizó' : 'Resolvió' }}
        {{ abierto.autorizaNombre }}<span *ngIf="abierto.autorizaPuesto">
          — {{ abierto.autorizaPuesto }}</span>
      </p>
    </div>

    <div class="pcal-modal__acciones">
      <button type="button" class="pcal-btn" *ngIf="tieneFrc(abierto)"
              [disabled]="generandoFrc === abierto.idPermiso"
              (click)="frcDe(abierto)">
        <span class="material-icons">picture_as_pdf</span>
        {{ generandoFrc === abierto.idPermiso ? 'Generando…' : 'FRC-017' }}
      </button>

      <span class="pcal-modal__aire"></span>

      <ng-container *ngIf="puedeResolver(abierto)">
        <button type="button" class="pcal-btn pcal-btn--no"
                [disabled]="resolviendo === abierto.idPermiso"
                (click)="rechazar(abierto)">
          <span class="material-icons">close</span>
          No autorizar
        </button>
        <button type="button" class="pcal-btn pcal-btn--ok"
                [disabled]="resolviendo === abierto.idPermiso"
                (click)="autorizar(abierto)">
          <span class="material-icons">check</span>
          {{ resolviendo === abierto.idPermiso ? 'Guardando…' : 'Autorizar' }}
        </button>
      </ng-container>

      <span class="pcal-modal__propio" *ngIf="esPropioPendiente(abierto)">
        Es tu propio permiso: lo resuelve tu líder.
      </span>
      <button type="button" class="pcal-btn" *ngIf="!puedeResolver(abierto)"
              (click)="cierra()">Cerrar</button>
    </div>
  </div>
</div>

<!-- La firma del FRC-017, la misma de la pestaña. -->
<app-firma-frc
  *ngIf="firmaAbierta"
  para="autorizar"
  documento="FRC-017"
  [nombre]="firmaObjetivo?.colaborador"
  (firmada)="firmada($event)"
  (cancelada)="cierraFirma()"
></app-firma-frc>
